import { Alert, App, Button } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { Form, FormField } from '@/Core/UI/Form'
import { classNames } from '@/Ship/Helpers/classNames'

import { PROFILE_TEXTS } from '../../Contracts/IProfile'

import type { ProfileManager } from '../../Stores/ProfileManager'

import styles from './UserProfile.module.css'

const FIELDS = {
    password: {
        label: 'Новий пароль',
        type: 'password',
        isRequired: true,
        inputProps: { placeholder: 'Новий пароль', autoComplete: 'new-password' },
    },
    passwordConfirmation: {
        label: 'Підтвердити новий пароль',
        type: 'password',
        isRequired: true,
        inputProps: { placeholder: 'Підтвердити новий пароль', autoComplete: 'new-password' },
    },
}

const text = (value: unknown): string => (typeof value === 'string' ? value : '')

/**
 * Вкладка «Змінити пароль» (легасі `ChangePassword/index.jsx`). Паролі
 * порівнюються до запиту — з розбіжністю форма нічого не відправляє (D-28,
 * С2.2). Після успіху — порожня форма.
 */
export const ChangePassword = observer(({ manager }: { manager: ProfileManager }) => {
    const { notification } = App.useApp()
    // Нова форма замість очищення: ядровий `Form` тримає контекст на весь час
    // життя компонента
    const [formKey, setFormKey] = useState(0)

    const onSubmit = async ({ values }: { values: Record<string, unknown> }): Promise<void> => {
        const changed = await manager.changePassword(text(values['password']), text(values['passwordConfirmation']))

        if (!changed) return

        setFormKey((key) => key + 1)
        notification.success({ title: PROFILE_TEXTS.passwordTitle, description: PROFILE_TEXTS.passwordSaved })
    }

    return (
        <Form key={formKey} fields={FIELDS} autoComplete="off" onSubmit={onSubmit}>
            <h3 className={classNames(styles['title'])}>Змінити пароль</h3>

            <div className={classNames(styles['grid'])}>
                <FormField name="password" />
                <FormField name="passwordConfirmation" />
            </div>

            {manager.passwordError ? (
                <Alert className={classNames(styles['alert'])} type="error" showIcon title={manager.passwordError} />
            ) : null}

            <div className={classNames(styles['buttons'])}>
                <Button type="primary" htmlType="submit" loading={manager.isPasswordSaving}>
                    Зберегти зміни
                </Button>
            </div>
        </Form>
    )
})
